{
  "version": 1,
  "asset_id": "af0af7ea-e967-48f6-a24c-0462acbfcf15",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/af0af7ea-e967-48f6-a24c-0462acbfcf15/hiatal-type-3-es-v3-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/af0af7ea-e967-48f6-a24c-0462acbfcf15/hiatal-type-3-es-v3-1200.webp",
  "original_filename": "hiatal-type-3-es-v3-1200.webp",
  "size": 185020,
  "content_type": "image/webp",
  "created_at": "2026-10-28T22:48:19Z"
}
